import { Component, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { LoggingService } from '../../../../shared/services/logging';
import * as fromInvoiceSetup from '../../../../data-services/invoice/setup';
import * as fromDataServices from '../../../../data-services';
import { SelectItem } from '../../../../shared';

@Component({
    selector: 'ef-invoice-address-add',
    templateUrl: './invoice-address-add.component.html',
    styleUrls: ['./invoice-address-add.component.scss'],
    standalone: false
})
export class InvoiceAddressAddComponent implements OnInit {
    @Input() addAddress: boolean;
    @Output() Cancel = new ReplaySubject();
    @Output() Save = new ReplaySubject();
    addAddressFormGroup: UntypedFormGroup;
    @Input() addressTypes: SelectItem[] = [];
    @Input() states: SelectItem[] = [];
    @Input() public set item(
        value: fromDataServices.Address.Address
    ) {
        this.log.verbose({
            type: 'InvoiceSelectionAddComponent:item:set',
            value
        });
        if (!!value) {
            this.addAddressFormGroup.setValue({
                id: value.id || -1,
                Addressid: value.Addressid || -1,
                AddressName: value.AddressName || null,
                Addr1: value.Addr1 || '',
                Addr2: value.Addr2 || '',
                Addr3: value.Addr3 || '',
                Addr4: value.Addr4 || '',
                City: value.City || '',
                State: value.State || '',
                PostalCode: value.PostalCode || '',
                AddressType: value.AddressType || null,
                Contact: value.Contact || null,
                AltContact: value.AltContact || null
            });
        }
    }
    constructor(private log: LoggingService) {
        this.addAddressFormGroup = new UntypedFormGroup({
            id: new UntypedFormControl(-1),
            Addressid: new UntypedFormControl(-1),
            AddressName: new UntypedFormControl(null),
            Addr1: new UntypedFormControl(null),
            Addr2: new UntypedFormControl(null),
            Addr3: new UntypedFormControl(null),
            Addr4: new UntypedFormControl(null),
            City: new UntypedFormControl(null),
            State: new UntypedFormControl(null),
            PostalCode: new UntypedFormControl(null),
            AddressType: new UntypedFormControl(null),
            Contact: new UntypedFormControl(null),
            AltContact: new UntypedFormControl(null)
        });
    }

    ngOnInit(): void {}
}
